import { forwardRef } from 'react';
import { cn } from '@/lib';
import type { EditableLableProps } from './EditableLable.types';

export const editableLableInputClassName =
  'border-primary bg-field text-onfield focus:ring-primary/30 w-full rounded-sm border px-2 py-1.5 text-sm focus:ring-2 focus:outline-none disabled:opacity-60';

// Renders either a controlled input or display content based on editing mode.
export const EditableLable = forwardRef<HTMLInputElement, EditableLableProps>(function EditableLable(
  {
    isEditing,
    value,
    setValue,
    onSet,
    onCancel,
    maxLength,
    disabled,
    children,
    inputClassName,
    ...inputProps
  },
  ref
) {
  if (!isEditing) {
    return <>{children}</>;
  }

  return (
    <input
      ref={ref}
      value={value}
      onChange={(event) => setValue(event.target.value)}
      onBlur={onSet}
      onPointerDown={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          onSet();
          return;
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          onCancel();
        }
      }}
      maxLength={maxLength}
      disabled={disabled}
      className={cn(editableLableInputClassName, inputClassName)}
      {...inputProps}
    />
  );
});
